var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleStoryteqContainer',{attrs:{"placeholder":_vm.placeholder,"video-key":_vm.videoKey,"param-name":_vm.paramName}})
}
var staticRenderFns = []

export { render, staticRenderFns }